import styled from "styled-components";
import { breakpointRuleDesktop, breakpointRuleGulliver, breakpointRuleTablet } from "../../library/utilities/variables";
import React from "react";
const CircleImg = styled.img.attrs({ alt: " " }) `
    position: absolute;
    left: -9px;
    bottom: 36px;

    transition: opacity 300ms ease-in-out;

    @media (${breakpointRuleTablet}) {
        bottom: 33%;
        left: 74px;
    }
`;
const PolyCharImg = styled.img.attrs({ alt: " " }) `
    position: relative;
    right: 0;
    bottom: -110px;

    transition: all 300ms ease-in-out;

    @media (${breakpointRuleTablet}) {
        width: 100%;
        bottom: 0;
    }
`;
const PolyCharImgStageTwo = styled.div.attrs({ 'aria-hidden': true }) `
    position: absolute;
    bottom: 0;
    right: 6px;

    width: 219px;
    height: 70px;
    background: url("/static/website/images_apps/pages/intro/polygon-up-diagonal-2.svg") no-repeat;

    transition: opacity 300ms ease-in-out;

    @media (${breakpointRuleTablet}) {
        width: 100%;
        height: 175px;
        background-image: url("/static/website/images_apps/pages/intro/polygon-up-diagonal-2-desktop.svg");
    }

    @media (${breakpointRuleGulliver}) {
        width: 195px;
    }
`;
const PolyChar = styled.div `
    position: absolute;
    bottom: 0;
    right: 0;
    transition: all 200ms ease-in-out;

    ${PolyCharImgStageTwo} {
        opacity: 0;
    }

    ${PolyCharImg} {
        opacity: 1;
    }

    &.stage-two {
        right: 1.5vw;

        ${PolyCharImgStageTwo} {
            opacity: 1;
        }

        ${PolyCharImg} {
            opacity: 0;
        }
    }

    @media (${breakpointRuleTablet}) {
        bottom: auto;
        top: max(62%, 374px);
        left: 60vw;
        right: auto;
        width: 222px;

        &.stage-two {
            width: 379px;
            height: 175px;
            left: calc(50% + ${142 - (379 / 2)}px);
            top: calc(100% - 175px);
        }
    }
`;
const AsteriskImg = styled.img.attrs({ alt: " " }) `
    position: absolute;
    bottom: calc(100vh - ${58 + 79}px);
    left: calc(100% - ${79 - 25}px);

    transition: all 300ms ease-in-out;

    &.stage-two {
        left: 9.5vw;
        bottom: -26px;
    }

    @media (${breakpointRuleTablet}) {
        top: 62px;
        left: calc(100% - ${79 - 10}px);

        &.stage-two {
            width: 142px;
            left: 21vw;
            top: 79%;
        }
    }
}
`;
const BackgroundLayerContainer = styled.div.attrs({ 'aria-hidden': true }) `
    z-index: -1;
    position: absolute;
    top: 0;
    right: -15px;
    bottom: 0;
    left: -15px;

    @media (${breakpointRuleTablet}) {
        right: -48px;
        left: -48px;
    }

    @media (${breakpointRuleDesktop}) {
        right: -15px;
        left: -15px;
    }

    ${({ secondStage }) => secondStage && `
        ${CircleImg} {
            opacity: 0;
        }
    `}
`;
export function IntroBackgroundLayer(props) {
    return (React.createElement(BackgroundLayerContainer, { secondStage: props.secondStage },
        React.createElement(CircleImg, { src: "/static/website/images_apps/pages/intro/circle-blue.svg" }),
        React.createElement(AsteriskImg, { className: props.secondStage && "stage-two", src: "/static/website/images_apps/pages/intro/asterisk.svg" }),
        React.createElement(PolyChar, { className: props.secondStage && "stage-two" },
            React.createElement(PolyCharImg, { src: "/static/website/images_apps/pages/intro/polygon-up-diagonal.svg" }),
            React.createElement(PolyCharImgStageTwo, null))));
}
